import React, { useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { useAdjustModel } from './adjustModel'
import { useAccountModel } from "../account/accountModel";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useOrgModel } from "@/views/organization/org/orgModel";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export const AdjustSearchBox = () => {
    const {
        supplierUserDs,
    } = useAccountModel();
    const { getOrgTreeSelect } = useOrgModel();
    const { beDs } = useGlobalModel();
    const {
        onReset,
        onSearch,
        searchParam,
        updateSearchParam,loadData
    } = useAdjustModel()


    const searchFields = [
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "组织机构",
            fieldName: "orgCode",
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "实体",
            fieldName: "beCode",
            options: beDs
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "账户名称",
            fieldName: "accountCode",
            options: supplierUserDs,
        }, {
            type: SearchTypeEnum.FmsRangePicker,
            fieldName: "adjustTimeRange",
            placeholder: ["起始日期", "结束日期"],
        },

    ]

    return (
        <YhBox style={{ paddingBottom: 0, margin: "15px 0px" }}>
            <YhPageHeader
                title=""
                justify="end"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                onFmsChange={updateSearchParam}
                                triggerSearch
                handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                handleReset={onReset}
            />
        </YhBox>
    )
}
